import * as t from 'io-ts';

export const token = t.type({
  expiresIn: t.union([t.null, t.number]),
  token: t.string,
  tokenType: t.string,
});

export type TokenData = t.TypeOf<typeof token>;
